import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { toDateTimeLocalValue } from '../medicine/medicine-date-time';
import { UseOfForceHygieneRestraintInput } from './use-of-force-api';

interface UseOfForceHygieneRestraintDialogProps {
  title: string;
  employeeName: string;
  startedAt?: Date;
  endedAt?: Date;
  onSave: (restraint: UseOfForceHygieneRestraintInput) => Promise<void>;
  onClose: () => void;
}

export function UseOfForceHygieneRestraintDialog(
  props: UseOfForceHygieneRestraintDialogProps
) {
  const { title, onSave, onClose } = props;
  const initialStart = toDateTimeLocalValue(props.startedAt ?? new Date());
  const [date, setDate] = useState(initialStart.slice(0, 10));
  const [from, setFrom] = useState(
    props.startedAt ? initialStart.slice(11, 16) : ''
  );
  const [to, setTo] = useState(
    props.endedAt ? toDateTimeLocalValue(props.endedAt).slice(11, 16) : ''
  );
  const [employeeName, setEmployeeName] = useState(props.employeeName);
  const [isSaving, setIsSaving] = useState(false);

  async function save() {
    setIsSaving(true);
    try {
      await onSave({
        startedAt: new Date(`${date}T${from}`),
        endedAt: new Date(`${date}T${to}`),
        employeeName,
      });
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <Dialog
      open
      onClose={() => (isSaving ? undefined : onClose())}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Dato"
            type="date"
            value={date}
            onChange={event => setDate(event.target.value)}
            slotProps={{ inputLabel: { shrink: true } }}
          />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="Fra kl."
              type="time"
              value={from}
              onChange={event => setFrom(event.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
              sx={{ flex: 1 }}
            />
            <TextField
              label="Til kl."
              type="time"
              value={to}
              onChange={event => setTo(event.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
              sx={{ flex: 1 }}
            />
          </Box>
          <TextField
            label="Navn på medarbejder"
            value={employeeName}
            onChange={event => setEmployeeName(event.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={isSaving}>
          Afbryd
        </Button>
        <Button
          variant="contained"
          onClick={save}
          disabled={isSaving || !date || !from || !to || !employeeName.trim()}
        >
          Gem
        </Button>
      </DialogActions>
    </Dialog>
  );
}
